// NGORegistration.jsx
import React from "react";

export default function NGORegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            NGO Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            NGO Registration Support in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks supports NGO Registration with proper legal
            structuring, helping non-profit organizations choose an appropriate
            format such as trust, society, or Section 8 company and align with
            statutory requirements.
          </p>
          <p className="text-gray-700">
            From drafting core constitutional documents to organizing member
            details and address proofs, the process is handled in a structured
            way so that your NGO can obtain formal recognition and start
            operating for its intended social objectives.
          </p>
        </div>

        {/* Right: Image (square style for consistency) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/6646910/pexels-photo-6646910.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Team working on NGO registration and compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for NGO Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps founders and members compile and format
              the information and proofs required for trust, society, or Section
              8 company registration, depending on the chosen structure.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>PAN card of the NGO or founding members, as applicable.</li>
                <li>
                  Identity proof of members / trustees / directors (Aadhaar,
                  passport, voter ID, or driving licence).
                </li>
                <li>
                  Residential address proof of key members (utility bill, bank
                  statement, or similar).
                </li>
                <li>
                  Registered office address proof (rent/lease agreement or
                  ownership document, recent utility bill, and NOC from owner if
                  required).
                </li>
                <li>
                  Basic constitutional documents such as draft trust deed,
                  Memorandum of Association, rules and regulations, or draft MOA
                  and AOA for Section 8 companies.
                </li>
                <li>
                  Photographs and contact details of founding members and
                  authorised signatories.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers non-profit oriented advisory and documentation
              support, helping NGOs align governance, objects, and compliance
              with legal expectations from the beginning.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Non-Profit Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Guidance on choosing between trust, society, or Section 8
                  company, and on meeting key registration and basic
                  post-registration compliance needs for NGOs.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Accurate Legal Documentation
                </h3>
                <p className="text-gray-700 text-sm">
                  Support in drafting and reviewing founding documents and
                  ensuring consistency between applications, member details, and
                  official proofs submitted to authorities.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Continued assistance from the initial idea and documentation
                  stage through registration and early compliance, providing a
                  reliable professional partner for your NGO.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
